import { UndergradLesson } from '@/models/undergrad/undegrad-lesson.model';

export interface UndergradLessonState {
  undergradLessons: { [key: string]: UndergradLesson };
}

const state: UndergradLessonState = {
  undergradLessons: {},
};

export default state;
